export class Resolver {
    static typeName() {
        throw new Error("typeName() implementation is required");
    }
    static isCompatibleWith(type) {
        return type === this.typeName();
    }
}
//# sourceMappingURL=types.js.map